import { render, staticRenderFns } from "./PerspCustomer.vue?vue&type=template&id=1d4e3dff&scoped=true&"
import script from "./PerspCustomer.vue?vue&type=script&lang=js&"
export * from "./PerspCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PerspCustomer.vue?vue&type=style&index=0&id=1d4e3dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e3dff",
  null
  
)

export default component.exports